
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface DescriptionFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const DescriptionField = ({ value, onChange }: DescriptionFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="description">Description</Label>
      <Textarea
        id="description"
        name="description"
        value={value}
        onChange={onChange}
        placeholder="Details about the reagent, such as purity, manufacturer, etc."
        className="min-h-[100px]"
      />
    </div>
  );
};

export default DescriptionField;
